const DEBUG_LOG = false;
import { makeLogger } from '@/services/utils/logger';
const log = makeLogger('App', DEBUG_LOG);
import Navbar from '@/components/layout/v2/NavbarV2/NavbarV2.vue';
import Footer from '@/components/layout/v2/FooterV2/FooterV2.vue';
import { defineAsyncComponent } from 'vue';
import emitter from '@/eventBus';
import ToastWrapper from '@/components/layout/ToastWrapper/ToastWrapper.vue';
import { useLoaderStore } from '@/stores/loader';
import LoaderUI from '@/components/layout/LoaderUI/LoaderUI.vue';


/**
 * Главный компонент приложения. Управляет навигацией, авторизацией и глобальными компонентами UI.
 */
export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    LoginDialog: defineAsyncComponent(() => import('@/components/Auth/LoginDialog/LoginDialog.vue')),
    ToastWrapper,
    LoaderUI
  },
  data() {
    return {
      isLoginVisible: false,
      showAuth: false,
      loader: useLoaderStore()
    };
  },
  watch: {
    isLoginVisible(val) {
      log('watch:isLoginVisible', 'Changed', { val });
    }
  },
  /**
   * Устанавливает слушатель для открытия диалога входа.
   */
  mounted() {
    emitter.on('open-login-dialog', () => {
      log('mounted', 'before open-login-dialog', { isLoginVisible: this.isLoginVisible });
      this.isLoginVisible = true;
      this.showAuth = true;
      log('mounted', 'after open-login-dialog', { isLoginVisible: this.isLoginVisible });
    });
  },
  methods: {
    /**
     * Обработчик закрытия диалога входа. Скрывает окно авторизации.
     */
    handleCloseLogin() {
      log('handleCloseLogin', 'called');
      this.isLoginVisible = false;
      this.showAuth = false;  
    }
  }
};
